<div class="container px-md-0">
  <div class="row">
    <div class="col-md-7 league-teams content">
      <app-promo-banner></app-promo-banner>
      <lib-betting-game-teaser *ngIf="league" [leagueId]="league.id"></lib-betting-game-teaser>
      <lib-ad-sponsor-banner
        *ngIf="league"
        [entityId]="league.id"
        [entityType]="entityType"
        [hideHeader]="true">
      </lib-ad-sponsor-banner>
      <ng-container *ngIf="teamsIsLoading === false; else loadingIndicator">
        <div class="team-cell" *ngFor="let team of teams">
          <app-team-cell
            [currentUser]="currentUser" [team]="team"
            (onFollowClick)="toggleFollow(true, $event)"
            (onUnfollowClick)="toggleFollow(false, $event)"
          ></app-team-cell>
        </div>
        <div *ngIf="teams == null || teams.length === 0">
          <p class="no-infos-available">Keine Teams gefunden</p>
        </div>
      </ng-container>
      <ng-template #loadingIndicator>
        <div class="container mb-5 mt-5">
          <mat-spinner strokeWidth="2" color="primary" diameter="54" class="m-auto"></mat-spinner>
        </div>
      </ng-template>
    </div>

    <div class="col-md-5 sidebar">
      <div class="row">
        <lib-ad class="col-12 mb-2"></lib-ad>
      </div>
    </div>
  </div>
</div>
